import axios from 'axios';

export const VENDOR_RECEIVED = 'VENDOR_RECEIVED';

const getVendor = () => (
  dispatch => (
    axios.get('/api/vendor')
      .then((response) => {
        dispatch({
          type: VENDOR_RECEIVED,
          vendor: response.data.data,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      })
  )
);

export default getVendor;
